




import { Component, Vue, Watch } from 'vue-property-decorator';
import InvestmentUploadSelect from '@/components/investment/InvestmentUploadSelect.vue';
import store from '@/store';
import { removeLoader } from '@/utils';

@Component({
  components: {
    InvestmentUploadSelect
  }
})
export default class InvestmentUploadSelectView extends Vue {
  created() {
    removeLoader();
  }
}
